class RecentlyViewedProducts {
  constructor() {
    this.containerEl = null;
    this.limit = 4;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.containerEl = document.querySelector('.recently-viewed-products');
    if (!this.containerEl) {
      return;
    }

    const recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
    const currentProductHandle = this.containerEl.dataset.productHandle;

    if (currentProductHandle) {
      const filteredProducts = recentlyViewedProducts.filter(handle => handle !== currentProductHandle);
      filteredProducts.unshift(currentProductHandle);
      const updatedProducts = filteredProducts.slice(0, this.limit + 1);

      localStorage.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));

      const displayProducts = updatedProducts.filter(handle => handle !== currentProductHandle).slice(0, this.limit);

      this.fetchRecentlyViewedProducts(displayProducts);
    }
  }

  // Get the current locale from the page URL or Shopify global variables
  getCurrentLocale() {
    // Method 1: Try to get from Shopify global variables
    if (typeof Shopify !== 'undefined' && Shopify.locale) {
      return Shopify.locale;
    }

    // Method 2: Extract from URL path (e.g., /en-us/products/... or /fr/products/...)
    const pathSegments = window.location.pathname.split('/').filter(segment => segment);
    const possibleLocale = pathSegments[0];
    
    // Check if first segment looks like a locale (2-5 characters, may contain hyphens)
    if (possibleLocale && /^[a-z]{2}(-[a-z]{2,3})?$/i.test(possibleLocale)) {
      return possibleLocale;
    }

    // Method 3: Try to get from HTML lang attribute
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      return htmlLang;
    }

    return 'en';
  }

  buildSearchUrl(query) {
    const locale = this.getCurrentLocale();
    const baseUrl = window.location.origin;
    
    const localePrefix = (locale && locale !== 'en') ? `/${locale}` : '';
    
    return `${baseUrl}${localePrefix}/search?q=${encodeURIComponent(query)}&type=product&view=recently-viewed`;
  }

  async fetchRecentlyViewedProducts(handles) {
    try {
      const query = handles.map(handle => `handle:${handle}`).join(' OR ');
      const url = this.buildSearchUrl(query);
      
      const response = await fetch(url);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const productGridItems = doc.querySelectorAll('.product-grid-item');
      const limitedProducts = Array.from(productGridItems).slice(0, 4);
      
      this.displayRecentlyViewedProducts(limitedProducts);
      
    } catch (error) {
      console.error('Error fetching recently viewed products:', error);
      this.containerEl.style.display = 'none';
    }
  }

  displayRecentlyViewedProducts(productElements) {
    const container = document.querySelector('.recently-viewed-products .products-list');
    if (!container) {
      return;
    }

    if (productElements.length === 0) {
      this.containerEl.style.display = 'none';
      return;
    }
    
    const slidesHtml = productElements.map(productElement => `
      <div class="swiper-slide">
        ${productElement.outerHTML}
      </div>
    `).join('');

    container.innerHTML = slidesHtml;
    this.containerEl.style.display = 'flex';
  }
}

new RecentlyViewedProducts();